import { render } from "./remote_user_resolver.vue?vue&type=template&id=7e42ae08"
import script from "./remote_user_resolver.js?vue&type=script&lang=js"
export * from "./remote_user_resolver.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__